import { Modal } from 'react-bootstrap';
import { Accordion } from 'Components/atoms';
import { Typography } from 'Components/atoms';
import { AiOutlineClose } from '@react-icons/all-files/ai/AiOutlineClose';
import { getDynamicVariablePaths } from './getDynamicVariablePaths';
import { useI18n } from 'Hooks/useI18n';
import './styles.scss';

const ENTITY_ORDER = ['finding', 'user', 'asset', 'provider'] as const;
const ENTITY_LABELS: Record<(typeof ENTITY_ORDER)[number], string> = {
    finding: 'Finding',
    user: 'User',
    asset: 'Asset',
    provider: 'Provider',
};

interface DynamicVariablesModalProps {
    show: boolean;
    onClose: () => void;
}

export const DynamicVariablesModal = ({ show, onClose }: DynamicVariablesModalProps) => {
    const { t } = useI18n();
    const paths = getDynamicVariablePaths();
    const accordionItems = ENTITY_ORDER.map((entity, index) => {
        const pathList = paths[entity] ?? [];
        const eventKey = String(index);
        return {
            key: eventKey,
            eventKey,
            title: ENTITY_LABELS[entity],
            isConfigurationRequired: false as const,
            children: (
                <ul className="dynamic-variables-modal__list">
                    {pathList.map((path: string) => (
                        <li key={path} className="dynamic-variables-modal__list-item">
                            <code>{`{{${path}}}`}</code>
                        </li>
                    ))}
                </ul>
            ),
        };
    });

    return (
        <Modal show={show} className="dynamic-variables-modal" onHide={onClose} centered>
            <Modal.Header>
                <Modal.Title>{t('DYNAMIC_VARIABLES_MODAL_TITLE')}</Modal.Title>
                <AiOutlineClose onClick={onClose} className="close-icon" data-testid="close-icon" aria-label="Close Help Modal" />
            </Modal.Header>
            <Modal.Body className="custom-scrollbar">
                <section className="dynamic-variables-modal__section">
                    <Typography variant="body5" color="text-high-emphasis">
                        {t('DYNAMIC_VARIABLES_MODAL_SYNTAX_DESCRIPTION')}
                    </Typography>
                </section>
                <section className="dynamic-variables-modal__section">
                    <Typography variant="subtitle7" color="text-high-emphasis" className="mb-2">
                        {t('DYNAMIC_VARIABLES_MODAL_PROPERTIES_SUBTITLE')}
                    </Typography>
                    <Typography variant="body5" color="text-high-emphasis" className="mb-3">
                        {t('DYNAMIC_VARIABLES_MODAL_PROPERTIES_DESCRIPTION')}
                    </Typography>
                    <Accordion accordionItems={accordionItems} defaultActiveKey={['0']} />
                </section>
            </Modal.Body>
        </Modal>
    );
};

export default DynamicVariablesModal;
